import { Box, Center, Spinner, Text, VStack, Image } from '@chakra-ui/react';
import dominus_logo_transparent_white from '../assets/dominus_logo_transparent_white.png';

const LoadingPage = () => {
  return (
    <Box
      minH="100vh"
      w="100%"
      position="absolute"
      top="0"
      left="0"
      bgGradient="linear(to-b, black, #002e0b)"
      color="white"
    >
      <Center h="100vh">
        <VStack gap={8}>
          <Image
            src={dominus_logo_transparent_white}
            alt="Dominus"
            h="120px"
            mb={4}
          />
          <Spinner
            size="xl"
            color="#16c60c"
          />
          <Text
            fontFamily="'Exo 2', sans-serif"
            fontSize="xl"
            color="white"
            opacity={0.8}
          >
            Loading...
          </Text>
        </VStack>
      </Center>
    </Box>
  );
};

export default LoadingPage; 